<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" data-title="렌탈" @rental="rental" :type="'order'" ref="header"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <div class="progress">
          <ol>
            <li><span>동의</span></li>
            <li><span>본인인증</span></li>
            <li class="on"><span>결제정보입력 및 확인</span></li>
            <li><span>계약서작성</span></li>
          </ol>
        </div>

        <section class="hr">
          <div class="titArea">
            <h2 class="titH3 normal">유의사항을 확인해 주세요.</h2>
          </div>

          <h3 class="label">유의사항</h3>
          <div class="boxMsg jqScroll" v-html="webview1"></div>

          <h3 class="label">상품안내사항</h3>
          <div class="boxMsg jqScroll" v-html="webview2"></div>
          <span class="singleIpt mt20">
            <input type="checkbox" class="ipt" name="jqscroll_chk" id="terms1" />
            <label for="terms1">상기 내용을 확인하였습니다.</label>
          </span>
          <div class="btnArea sticky">
            <button type="button" class="btn_p" @click="putRentalOrder">
              다음
            </button>
          </div>
        </section>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
    <MessagePop v-if="messagePop" @close="close">
      <p v-html="msg"></p>
    </MessagePop>
    <ConfirmPop @cancel="cancel" @confirm="confirm" v-if="confirmPop" @close="close">
      <p v-html="msg"></p>
    </ConfirmPop>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import ApiService from '@/common/api.service';
import MessagePop from '@/components/popup/MessagePop';
import { TERM_AGREE_CHECK, GO_HOME } from '@/store/message.type.js';
import 'jquery.scrollbar';
import ConfirmPop from '@/components/popup/ConfirmPop';
export default {
  name: 'guestStep5',
  components: {
    MessagePop,
    ConfirmPop,
  },
  async mounted() {
    this.request = this.$route.params.request;
    console.log(this.request);
    let webViews = await ApiService.service('GET', 'common/webView/WB000001');
    this.webViews = webViews.data.result;
    console.log(this.webViews[0].filePath);
    // eslint-disable-next-line no-unused-vars
    let data1 = await ApiService.service('GET', this.webViews[0].filePath).catch(err => {});
    this.webview1 = data1.data;
    // eslint-disable-next-line no-unused-vars
    let data2 = await ApiService.service('GET', this.webViews[1].filePath).catch(err => {});
    this.webview2 = data2.data;
  },
  data: function() {
    return {
      request: null,
      msg: null,
      messagePop: false,
      confirmPop: false,
      pop: null,
      webview1: null,
      webview2: null,
    };
  },
  methods: {
    nextStep: function() {
      if (this.validate()) this.$router.push({ name: 'guestStep6', params: { request: this.request } });
      else {
        this.pop = MessagePop;
        this.msg = TERM_AGREE_CHECK;
        this.messagePop = true;
      }
    },
    validate: function() {
      const chk1 = document.getElementById('terms1').checked;

      if (chk1) {
        return true;
      } else {
        return false;
      }
    },
    putRentalOrder: function() {
      if (this.validate() == false) {
        this.pop = MessagePop;
        this.msg = TERM_AGREE_CHECK;
        this.messagePop = true;
        return false;
      }
      this.request.orderCommInfo.orderStatus = 'RSTA00RP';
      this.$refs.header.loadingStart(); // 로딩끝
      ApiService.service('POST', '/order/rental', {
        request: this.request,
        serviceType: 'app',
      })
        .then(({ data }) => {
          console.log(data);
          if (data.isSucceed == true) {
            this.request.orderCommInfo.orderId = data.result.orderId;
            this.nextStep();
          } else {
            this.pop = MessagePop;
            this.msg = data.error;
            this.messagePop = true;
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        })
        .finally(() => {
          this.$refs.header.loadingEnd(); // 로딩끝
        });
    },
    close() {
      this.messagePop = false;
      this.confirmPop = false;
      this.bottomPop = false;
      this.noticePop = false;
      this.webViewPop = false;
      this.sharePop = false;
      this.findAddr = false;
    },
    rental: function() {
      this.msg = GO_HOME;
      this.confirmPop = true;
    },
    cancel: function() {
      // 취소 선택시 팝업 닫기
      this.confirmPop = false;
    },
    confirm: function() {
      // 확인 선택시 장바구니에 담고 페이지이동
      // TODO 장바구니 추가 API 호출
      this.$router.replace('/');
    },
  },
};
</script>
